document.addEventListener('click', function (event) {
  const button = event.target.closest('.expandable-richtext__toggle');

  if (!button) return;

  const wrapper = button.closest('.expandable-richtext');

  if (!wrapper) return;

  wrapper.classList.toggle('expanded');

  if (wrapper.classList.contains('expanded')) {
    button.textContent = button.dataset.close;
  } else {
    button.textContent = button.dataset.open;
  }
});